const TAG_SALE_STATUS = {
  UNVERIFIED: 'unverified'
};
export default function createAlertVariant(keys, value) {
  const match = Object.entries(keys).find(([keys, valueInfo]) => valueInfo?.tagSerialNumber?.includes(value));
  if (match) {
    const [key, valueInfo] = match;

    // Check the tagSaleStatus and push to alertsVariant accordingly
    if (valueInfo.tagSaleStatus === TAG_SALE_STATUS.UNVERIFIED) {
      return 'pillTagWarning';
    }
    return 'pillTag';
  }
  return '';
}